import {
  authCapturePayment,
  getPaymentSettings,
  cancelPayment,
  createPaymentIntiation,
  createLinkTokenForPaymentInitiation,
  postValidateIBTPayment,
  getPaymentDetails,
  cancelPaymentIntiation,
  createUnionPayment,
  createStripePayment,
  updatePaymentOperation,
  createInvoicePayment,
  postWorldPay3dsLogs,
  createTransfermatePayment
} from '../../api/api'

import { all, takeLatest, call, put, select } from 'redux-saga/effects'
import { LOGOUT } from 'portal-modules/auth/redux/modules/user'
import createRequestSaga, {
  handleResponseError,
} from 'portal-modules/common/redux/create-request-saga'
import createFormAction from 'portal-modules/common/redux/create-form-action'
import { addSettings } from 'portal-modules/common/redux/modules/settings'
import { requestLedgerSettings } from 'portal-modules/ledger/redux/modules/ledger'
import { addPaymentMethod } from './paymentMethods'
import { addCustomContent } from 'portal-modules/common/redux/modules/customContent'
import { showCancelPaymentSuccess } from 'portal-modules/common/redux/modules/toggleSuccessModals'
import { addError } from 'portal-modules/common/redux/modules/errors'
import {
  PAYMENT_TYPES,
  PAYMENT_TYPES_BY_ID,
} from 'portal-modules/payments/constants'
import { isObject } from '@entrata/utils'
import { requestBalanceDue } from 'portal-modules/common/redux/modules/balanceDue'
import { requestBalanceDetails } from 'portal-modules/common/redux/modules/balanceDetails'

// action types
const MAKE_A_PAYMENT = 'rp/payments/MAKE_A_PAYMENT'
export const POSTED_PAYMENT = 'rp/payments/POSTED_PAYMENT'
const MAKE_PAYMENT_INIT = 'rp/payments/MAKE_PAYMENT_INIT'
const PAYMENT_INIT_LINK_TOKEN = 'rp/payments/PAYMENT_INIT_LINK_TOKEN'
const REQUEST_PAYMENT_SETTINGS = 'rp/payments/REQUEST_PAYMENT_SETTINGS'
const CANCEL_A_PAYMENT = 'rp/payments/CANCEL_A_PAYMENT'
const VALIDATE_PAYMENT_INIT = 'rp/payments/VALIDATE_PAYMENT_INIT'
const CANCEL_PAYMENT_INIT = 'rp/payments/CANCEL_PAYMENT_INIT'
const CLEAR_DUPLICATE_PAYMENT_FLAG = 'rp/payments/CLEAR_DUPLICATE_PAYMENT_FLAG'
const REQUEST_PAYMENT_DETAILS = 'rp/payments/REQUEST_PAYMENT_DETAILS'
const MAKE_UNION_PAYMENT = 'rp/payments/MAKE_UNION_PAYMENT'
const MAKE_STRIPE_PAYMENT = 'rp/payments/MAKE_STRIPE_PAYMENT'
const MAKE_INVOICE_PAYMENT = 'rp/payments/MAKE_INVOICE_PAYMENT'
const HANDLE_PAYMENT_OPERATION = 'rp/payments/HANDLE_PAYMENT_OPERATION'
const WORLDPAY_PAYMENT_LOGS = 'rp/payments/WORLDPAY_PAYMENT_LOGS'
const MAKE_TRANSFERMATE_PAYMENT = 'rp/payments/MAKE_TRANSFERMATE_PAYMENT'

// reducer
export default (state = {}, { payload, type }) => {
  switch (type) {
    case POSTED_PAYMENT:
      return payload
    case LOGOUT:
      return {}
    default:
      return state
  }
}

// action creators
export const makeAPayment = createFormAction(MAKE_A_PAYMENT)

export const clearDuplicatePyamentFlag = () => ({
  type: CLEAR_DUPLICATE_PAYMENT_FLAG,
})

export const makePaymentInit = (payload, callback) => ({
  type: MAKE_PAYMENT_INIT,
  payload: payload,
  callback: callback,
})

export const paymentInitLinkToken = (payload, callback) => ({
  type: PAYMENT_INIT_LINK_TOKEN,
  payload: payload,
  callback: callback,
})

export const cancelPaymentNow = (payload, callback) => ({
  type: CANCEL_A_PAYMENT,
  payload: payload,
  callback: callback,
})

export const requestPaymentSettings = () => ({
  type: REQUEST_PAYMENT_SETTINGS,
})

export const requestPaymentDetails = (payload, callback) => ({
  type: REQUEST_PAYMENT_DETAILS,
  payload,
  callback,
})

export const validatePaymentInit = (payload, callback) => ({
  type: VALIDATE_PAYMENT_INIT,
  payload,
  callback,
})
export const requestCancelPaymentInitiation = (payload, callback) => ({
  type: CANCEL_PAYMENT_INIT,
  payload,
  callback,
})

export const makeUnionPayment = (payload, callback) => ({
  type: MAKE_UNION_PAYMENT,
  payload: payload,
  callback: callback,
})

export const makeStripePayment = (payload, callback) => ({
  type: MAKE_STRIPE_PAYMENT,
  payload: payload,
  callback: callback,
})

export const makeInvoicePayment = (payload, callback) => ({
    type: MAKE_INVOICE_PAYMENT,
    payload: payload,
    callback: callback,
})

export const handlePaymentOperation = (payload, callback) => ({
  type: HANDLE_PAYMENT_OPERATION,
  payload: payload,
  callback: callback,
})

export const worldpayPaymentLogs = (payload) => ({
  type: WORLDPAY_PAYMENT_LOGS,
  payload: payload
})

export const makeTransfermatePayment = (payload, callback) => ({
  type: MAKE_TRANSFERMATE_PAYMENT,
  payload: payload,
  callback: callback,
})

// sagas
function* postWorldPayPaymentLogs({ payload }) {
  yield call(postWorldPay3dsLogs, localStorage.getItem('ddc_detail_log'))
}


// sagas
function* postPaymentInit({ payload }) {
  const response = yield call(createPaymentIntiation, payload.payload)
  if (typeof payload.callback == 'function') {
    payload.callback(response)
  }
  if (typeof response === 'string' && response.startsWith('<pre>')) {
    throw new Error(__('Payment failed'))
  }
}

// sagas
function* postCreateUnionPayment({ payload }) {
  const response = yield call(createUnionPayment, payload.payload)
  if (typeof payload.callback == 'function') {
    payload.callback(response)
  }
  if (typeof response === 'string' && response.startsWith('<pre>')) {
    throw new Error(__('Payment failed'))
  }
}

// sagas
function* postCreateStripePayment({ payload }) {
  const response = yield call(createStripePayment, payload.payload)
  if (typeof payload.callback == 'function') {
    payload.callback(response)
  }
  if (typeof response === 'string' && response.startsWith('<pre>')) {
    throw new Error(__('Payment failed'))
  }
}

function* postCreateTransfermatePayment({ payload }) {
  const response = yield call(createTransfermatePayment, payload.payload)
  if (typeof payload.callback == 'function') {
    payload.callback(response)
  }
  if (typeof response === 'string' && response.startsWith('<pre>')) {
    throw new Error(__('Payment failed'))
  }
}

function* postCreateInvoicePayment({ payload }) {
  const response = yield call(createInvoicePayment, payload.payload)
  if (typeof payload.callback == 'function') {
    payload.callback(response)
  }
  if (typeof response === 'string' && response.startsWith('<pre>')) {
    throw new Error(__('Payment failed'))
  }
}

// sagas
function* postUpdatePaymentOperation({ payload }) {
  const response = yield call(updatePaymentOperation, payload.payload)
  if (typeof payload.callback == 'function') {
    payload.callback(response)
  }
  if (typeof response === 'string' && response.startsWith('<pre>')) {
    throw new Error(__('Payment failed'))
  }
}

function* postPaymentInitLinkToken({ payload }) {
  const response = yield call(
    createLinkTokenForPaymentInitiation,
    payload.payload,
  )
  if (typeof payload.callback == 'function') {
    yield payload.callback(response)
  }
  if (typeof response === 'string' && response.startsWith('<pre>')) {
    throw new Error(__('Payment failed'))
  }
}

function* postPayment({ payload, type, callback, isOneTapPay = false }) {
  let response = yield call(authCapturePayment, payload)
  if (payload.save_to_wallet) {
    const walletInfo = {
      payload: {
        agrees_to_terms: payload.agrees_to_terms,
        [payload?.card_info
          ? 'card_info'
          : payload.bank_info
          ? 'bank_info'
          : 'sepa_info']: payload?.card_info
          ? payload?.card_info
          : payload.bank_info
          ? payload.bank_info
          : payload.sepa_info,
        nickname: payload.nickname,
        payment_type_id: payload.payment_type_id,
        save_to_wallet: payload.save_to_wallet,
      },
    }
    yield put(addPaymentMethod(walletInfo))
  }

  if (typeof response === 'string' && response.startsWith('<pre>')) {
    // throw new Error(__('Payment failed'))
    let responsesWithPre = response.split('</pre>')
    let responseString = responsesWithPre.pop() // Get the last Array Element
    response = JSON.parse(responseString)
  }

  if (!isObject(response)) {
    throw new Error(__('There was an error while processing payment'))
  }

  const {
    payments,
    requires_3dsecure,
    threed_secure_iframe_url,
    use_3ds_flex,
    issuer_url,
    secure_postback,
    md_data,
    challenge_token,
  } = response

  const { user } = yield select()
  const rp_at = user?.token

  const additionalVerificationDetails = {
    requires3dSecure: requires_3dsecure,
    iframeUrl: `${threed_secure_iframe_url}&is_react_dev=${
      process.env.NODE_ENV === 'development'
    }&auth_token=${rp_at}`,
    use3dsFlex: use_3ds_flex,
    issuerUrl: issuer_url,
    securePostBack: `${secure_postback}&is_react_dev=${
      process.env.NODE_ENV === 'development'
    }`,
    mdData: md_data,
    challengeToken: challenge_token,
  }

  if (payments.length && type === MAKE_A_PAYMENT) {
    let actions = []

    actions.push({
      type: POSTED_PAYMENT,
      payload: {
        ...response,
        paymentTypeId: payload?.payment_type_id,
        paymentAccountId: payload?.customer_payment_account_id,
      },
    })

    actions.push(requestLedgerSettings())
    actions.push(requestBalanceDue())
    actions.push(requestBalanceDetails())

    const {
      settings: { payments },
    } = yield select()

    if (payments?.is_duplicate_payment) {
      actions.push(
        addSettings({ payments: { ...payments, is_duplicate_payment: false } }),
      )
    }

    yield all(actions.map(a => put(a)))
  }

  if (requires_3dsecure) {
    callback(payments[0].id, additionalVerificationDetails)
  } else {
    if (isOneTapPay) {
      callback(payments[0].id, false)
    } else {
      callback(payments[0].id)
    }
  }
}

function* cancelAPayment({ payload, callback }) {
  const response = yield call(cancelPayment, payload)
  if (response.code == 200) {
    yield put(showCancelPaymentSuccess(true))
  } else {
    callback(response);
    throw new Error(__(response.message))
  }
}

function* handleAuthCapturePaymentError(
  err,
  { action: { isOneTapPay, callback } },
) {
  if (err.code == 3137) {
    let [firstPayment] = err.fields.filter(field => field?.payment_id) || []
    if (typeof callback == 'function') {
      if (isOneTapPay) {
        callback(firstPayment?.payment_id || 0, true)
      } else {
        callback(firstPayment?.payment_id || 0, false, true)
      }
    }

    return
  }

  if (err.code == 90033) {
    yield put(addError({ key: 'payments', message: err }))
    return
  }

  if ([3133, 3134].includes(err.code)) {
    const {
      settings: { payments },
    } = yield select()
    yield payments &&
      isObject(payments) &&
      put(
        addSettings({
          payments: { ...payments, is_duplicate_payment: true },
        }),
      )
  }

  yield call(handleResponseError, err, { key: 'payments' })
}

function* handlePaymentError(err) {
  if (err.code == 90033) {
    yield put(addError({ key: 'payments', message: err }))
    return
  }
  if ([3133, 3134].includes(err.code)) {
    const {
      settings: { payments },
    } = yield select()
    yield payments &&
      isObject(payments) &&
      put(
        addSettings({
          payments: { ...payments, is_duplicate_payment: true },
        }),
      )
  }

  yield call(handleResponseError, err, { key: 'payments' })
}

function* fetchPaymentSettings() {
  const {
    settings: { payments },
  } = yield select()

  let paymentSettings = {}
  if (payments && isObject(payments)) {
    let rewardSettings = yield call(getPaymentSettings)
    const { is_duplicate_payment, ...currentPaymentSettings } = payments
    paymentSettings = { ...currentPaymentSettings,
      is_reward_points_payment_enabled: rewardSettings?.is_reward_points_payment_enabled,
      reward_points_details: rewardSettings?.reward_points_details }
  }
  if (
    false ==
    (paymentSettings &&
      isObject(paymentSettings) &&
      Object.values(paymentSettings).length)
  ) {
    paymentSettings = yield call(getPaymentSettings)
  }

  yield put(
    addSettings({
      payments: { ...paymentSettings, is_duplicate_payment: false },
    }),
  )
  yield put(addCustomContent({ payments: paymentSettings.custom_text }))
}

function* postValidatePaymentInit({ payload, callback }) {
  const response = yield call(postValidateIBTPayment, payload?.payment_info)
  if (typeof callback == 'function') {
    callback()
  }
}

function* postCancelPaymentInit({ payload, callback }) {
  yield call(cancelPaymentIntiation, payload)
  if (typeof callback == 'function') {
    callback()
  }
}

function* clearDuplicatePaymentFlag() {
  const {
    settings: { payments },
  } = yield select()

  yield payments &&
    isObject(payments) &&
    put(
      addSettings({
        payments: { ...payments, is_duplicate_payment: false },
      }),
    )
}

function* watchClearDuplicatePaymentFlag() {
  yield takeLatest(
    CLEAR_DUPLICATE_PAYMENT_FLAG,
    createRequestSaga(clearDuplicatePaymentFlag, {
      key: 'duplicatePayment',
    }),
  )
}

function* fetchPaymentDetails({ payload }) {
  const { arPaymentId } = payload || {}
  const response = yield call(getPaymentDetails, { ar_payment_id: arPaymentId })
  if (!isObject(response) || !isObject(response?.payment_details)) return true
  else if (response) {
    const { payment_details } = response
    const paymentType =
      PAYMENT_TYPES[
        PAYMENT_TYPES_BY_ID[parseInt(payment_details.payment_type_id)]
      ]
    yield put({
      type: POSTED_PAYMENT,
      payload: {
        payments: [
          {
            ...payment_details,
            payment_type: paymentType.getName(),
          },
        ],
        paymentAccountId: 0,
        paymentTypeId: paymentType.value,
        total_amount: payment_details?.payment_amount,
      },
    })
  }
}

function* watchPaymentInitiation() {
  yield takeLatest(
    MAKE_PAYMENT_INIT,
    createRequestSaga(postPaymentInit, {
      key: 'makePayment',
      message: __('Initiating your payment'),
      successMessage: '',
      onError: handlePaymentError,
      write: true,
    }),
  )
}

function* watchMakeUnionPayment() {
  yield takeLatest(
    MAKE_UNION_PAYMENT,
    createRequestSaga(postCreateUnionPayment, {
      key: 'makePayment',
      message: __('Initiating your payment'),
      successMessage: '',
      onError: handlePaymentError,
      write: true,
    }),
  )
}

function* watchMakeStripePayment() {
  yield takeLatest(
    MAKE_STRIPE_PAYMENT,
    createRequestSaga(postCreateStripePayment, {
      key: 'makePayment',
      message: __('Initiating your payment'),
      successMessage: '',
      onError: handlePaymentError,
      write: true,
    }),
  )
}

function* watchMakeInvoicePayment() {
  yield takeLatest(
    MAKE_INVOICE_PAYMENT,
    createRequestSaga(postCreateInvoicePayment, {
      key: 'makePayment',
      message: __('Initiating your payment'),
      successMessage: __('Redirecting...'),
      onError: handlePaymentError,
      write: true,
    }),
  )
}

function* watchUpdatePaymentOperation() {
  yield takeLatest(
    HANDLE_PAYMENT_OPERATION,
    createRequestSaga(postUpdatePaymentOperation, {
      key: 'makePayment',
      message: __('Updating payment Status'),
      successMessage: '',
      onError: handlePaymentError,
      write: true,
    }),
  )
}

function* watchPaymentInitLinkToken() {
  yield takeLatest(
    PAYMENT_INIT_LINK_TOKEN,
    createRequestSaga(postPaymentInitLinkToken, {
      key: 'makePayment',
      message: __('Launching Payment'),
      successMessage: '',
      onError: handlePaymentError,
      write: true,
    }),
  )
}

function* watchNewPayment() {
  yield takeLatest(
    MAKE_A_PAYMENT,
    createRequestSaga(postPayment, {
      key: 'makePayment',
      message: __('Processing payment'),
      successMessage: __('Your payment was successful!'),
      onError: handleAuthCapturePaymentError,
      write: true,
    }),
  )
}

function* watchRequestPaymentSettings() {
  yield takeLatest(
    REQUEST_PAYMENT_SETTINGS,
    createRequestSaga(fetchPaymentSettings, {
      key: 'payments',
      messgae: __('Looking up payment settings'),
      duration: 500,
    }),
  )
}

function* watchCancelPayment() {
  yield takeLatest(
    CANCEL_A_PAYMENT,
    createRequestSaga(cancelAPayment, {
      key: 'payments',
      message: __('Cancelling Payment'),
      successMessage: __('Payment Cancelled Successfully'),
      onError: handlePaymentError,
      write: true,
    }),
  )
}

function* watchValidatePaymentInitiation() {
  yield takeLatest(
    VALIDATE_PAYMENT_INIT,
    createRequestSaga(postValidatePaymentInit, {
      key: 'makePayment',
      successMessage: '',
      onError: handlePaymentError,
      write: true,
    }),
  )
}

function* watchCancelPaymentInitiation() {
  yield takeLatest(
    CANCEL_PAYMENT_INIT,
    createRequestSaga(postCancelPaymentInit, {
      key: 'makePayment',
      message: __('Canceling payment'),
      successMessage: '',
      onError: handlePaymentError,
      write: true,
    }),
  )
}

function* watchRequestPaymentDetails() {
  yield takeLatest(
    REQUEST_PAYMENT_DETAILS,
    createRequestSaga(fetchPaymentDetails, {
      key: 'makePayment',
      message: __('fetching payment'),
      successMessage: '',
      onError: handlePaymentError,
      write: true,
    }),
  )
}


function* watchWorldPaypaymentLogs() {
  yield takeLatest(
    WORLDPAY_PAYMENT_LOGS,
    createRequestSaga(postWorldPayPaymentLogs, {
      key: 'worldpayPaymentLogs',
      message: __('DDC Log payment'),
      write: true,
    }),
  )
}

function* watchMakeTransfermatePayment() {
  yield takeLatest(
    MAKE_TRANSFERMATE_PAYMENT,
    createRequestSaga(postCreateTransfermatePayment, {
      key: 'makePayment',
      message: __('Initiating your payment'),
      successMessage: '',
      onError: handlePaymentError,
      write: true,
    }),
  )
}

export const sagas = [
  watchNewPayment,
  watchRequestPaymentSettings,
  watchCancelPayment,
  watchPaymentInitiation,
  watchPaymentInitLinkToken,
  watchValidatePaymentInitiation,
  watchCancelPaymentInitiation,
  watchClearDuplicatePaymentFlag,
  watchRequestPaymentDetails,
  watchMakeUnionPayment,
  watchMakeStripePayment,
  watchMakeInvoicePayment,
  watchUpdatePaymentOperation,
  watchWorldPaypaymentLogs,
  watchMakeTransfermatePayment
]
